import { useEffect, useCallback, useMemo, useRef, useState } from "react";
import giftImage from "../images/gift.svg";
import dropDown from "../images/chevron-down.svg";
import { ReactComponent as WarningIcon } from "../images/warning-icon.svg";
import "./LoanDetail.scss";
import "../scss/popup.scss";
import infoIcon from "../images/info-black-con.svg";
import CenteredPopup from "../components/popups/CenteredPopup";
import { ReactComponent as ShieldIcon } from "../images/shield-icon.svg";
import { ReactComponent as Alert } from "../images/Alert.svg";
import { ReactComponent as MaroonTick } from "../images/MaroonTick.svg";
import { ReactComponent as Cars2 } from "../images/Cars2.svg";
import { ReactComponent as CreditReport } from "../images/CreditReport.svg";
import { ReactComponent as MagnifyDoc } from "../images/MagnifyDoc.svg";
import { ReactComponent as RupeeDocs } from "../images/RupeeDocs.svg";
import { ReactComponent as SquiglyTick } from "../images/SquiglyTick.svg";
import { ReactComponent as CreditMeter } from "../images/CreditMeter.svg";
import {
  useGetPartnerLocMutation,
  useGetPartnerLocConfirmMutation,
  useDisbursalDisburseMutation,
  useGetLoanbankDetailsMutation,
  useGetCustomerFeatureFlagMutation,
} from "../lib/services/eligibilityApi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setPageError,
  setPartnerLocDetails,
  setIfscBankDetails,
  setCustomerFeatureFlag,
} from "../lib/features/eligibilitySlice";
import PageHeader from "../components/PageHeader";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import BottomPopup from "../components/popups/BottomPopup";
import { useTapClickMutation } from "../lib/middleware/TapClickApi";
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

const LoanDetail = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [checked, setChecked] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  const [showCreditShieldPopup, setShowCreditShieldPopup] = useState(false);
  const [showCreditReportPopup, setShowCreditReportPopup] = useState(false);
  const [showFinalGatingPopup, setShowFinalGatingPopup] = useState(false);
  const [showEmiAmountPopup, setShowEmiAmountPopup] = useState(false)

  const [creditShieldChecked, setCreditShieldChecked] = useState(false);
  const [creditReportChecked, setCreditReportChecked] = useState(false);

  const [
    creditShieldToggleActionPerformed,
    setCreditShieldToggleActionPerformed,
  ] = useState(false);
  const [
    creditReportToggleActionPerformed,
    setCreditReportToggleActionPerformed,
  ] = useState(false);
  const [skipCreditShield, setSkipCreditShield] = useState(false);
  const [expandedTile, setExpandedTile] = useState(null);

  const [disablebtn, setdisablebtn] = useState(false);
  const [showRefreshPopup, setShowRefreshPopup] = useState(false);
  const [refreshCountdown, setRefreshCountdown] = useState(5);
  const [getPartnerLoc, { isLoading: locLoading }] = useGetPartnerLocMutation();
  const [getPartnerLocConfirm, { isLoading: locConfirmLoading }] =
    useGetPartnerLocConfirmMutation();
  const [getLoanbankDetails, { isLoading: loanDetailLoading }] =
    useGetLoanbankDetailsMutation();
  const [DisbursalDisburse, { isLoading: disbursalLoading }] =
    useDisbursalDisburseMutation();
  const [getCustomerFeatureFlag, { isLoading: featureFlagLoading }] =
    useGetCustomerFeatureFlagMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const utmSource = useMemo(() => queryParams.get("utm_source"), [queryParams]);
  const jwt = useMemo(() => queryParams.get("jwt_token"), [queryParams]);
  const secret = useMemo(() => queryParams.get("secret"), [queryParams]);
  const deviceid = useMemo(() => queryParams.get("device_id"), [queryParams]);
  const { partnerLocDetails, pageerror, ifscBankDetails, customerFeatureFlag } =
    useSelector((state) => state.eligibility);
  
  const [tapClick] = useTapClickMutation()

  const [emiAmountData, setEmiAmountData] = useState({
    totalPayableAmount: "",
    loanAmount: "",
    effectiveRoi: "",
    annualPercentageRate: "",
    interestPayable: "",
    financeDoc: "",
    effectiveAnnualRoi: ""
  });

  const isLoading =
    locLoading || loanDetailLoading || disbursalLoading || featureFlagLoading;

  const isInitialized = useRef(false);

  const creditShieldRef = useRef(creditShieldChecked);
  const creditReportRef = useRef(creditReportChecked);

  useEffect(() => {
    creditShieldRef.current = creditShieldChecked;
  }, [creditShieldChecked]);

  useEffect(() => {
    creditReportRef.current = creditReportChecked;
  }, [creditReportChecked]);

  useEffect(() => {
    if (!showRefreshPopup) return;
    if (refreshCountdown <= 0) {
      window.location.reload();
      return;
    }
    const timer = setTimeout(() => {
      setRefreshCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [showRefreshPopup, refreshCountdown]);

  const handleToggleExpand = (tileId) => {
    setExpandedTile((prev) => (prev === tileId ? null : tileId));
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCreditShieldPopup = () => {
    setShowCreditShieldPopup(!showCreditShieldPopup);
  };

  const handleCreditReportPopup = () => {
    setShowCreditReportPopup(!showCreditReportPopup);
  };

  const handleEmiReportPopup = () => {
    setShowEmiAmountPopup(!showEmiAmountPopup);
  };

  const handleEmiReportPopupClose = () => {
    setShowEmiAmountPopup(false);
  };

  const handleFinalGatingPopup = () => {
    setShowFinalGatingPopup(!showFinalGatingPopup);
  };

  const handleFinalGatingSkip = () => {
    setSkipCreditShield(true);
  };

  const handleFinalGatingProceed = () => {
    GetBankInfo();
  };

  const handleCreditPopupClose = () => {
    setShowCreditShieldPopup(false);
    setShowCreditReportPopup(false);
    setShowFinalGatingPopup(false);
    setSkipCreditShield(false);
  };

  const handleProtectMeButtonClick = () => {
    if (showCreditShieldPopup) {
      setCreditShieldChecked(true);
      setCreditShieldToggleActionPerformed(true);
      handleCreditPopupClose();
    } else if (showFinalGatingPopup) {
      setCreditShieldChecked(true);
      setCreditShieldToggleActionPerformed(true);
      handleCreditPopupClose();
      handleFinalGatingProceed();
    }
  };

  const handleCreditShieldPopupButtons = (button) => {
    if (showCreditShieldPopup) {
      if (button === "stay-unprotected") {
        handleCreditPopupClose();
      } else if (button === "protect-me") {
        setCreditShieldChecked(true);
        setCreditShieldToggleActionPerformed(true);
        handleCreditPopupClose();
      }
    } else if (showCreditReportPopup) {
      if (button === "stay-unprotected") {
        handleCreditPopupClose();
      } else if (button === "protect-me") {
        setCreditReportChecked(true);
        setCreditReportToggleActionPerformed(true);
        handleCreditPopupClose();
      }
    } else if (showFinalGatingPopup) {
      if (button === "stay-unprotected") {
        handleFinalGatingProceed();
      } else if (button === "protect-me") {
        setCreditShieldChecked(true);
        setCreditShieldToggleActionPerformed(true);
        handleCreditPopupClose();
        handleFinalGatingProceed();
      }
    }
  };

  const handleCreditReportPopupClose = () => {
    setCreditReportChecked(true);
    setCreditReportToggleActionPerformed(true);
    handleCreditPopupClose();
  };

  const LoanInfoTile = ({
    isExpandable = false,
    label,
    value,
    dropDownContent,
    showDivider = true,
    isExpanded,
    onToggleExpand,
    showInfoIcon=false,
    onInfoIconClick=()=>{}
  }) => {
    const handleExpandClick = () => {
      if (isExpandable && onToggleExpand) {
        onToggleExpand();
      }
    };

    return (
      <div
        className="loan-info-tile-container"
        style={{
          borderBottom:
            isExpanded || showDivider === false ? "" : "1px solid #E9E9E9",
        }}
      >
        <div className="loan-info-tile-title" onClick={handleExpandClick}>
          <p className="label">{label}{showInfoIcon && <img onClick={onInfoIconClick} style={{marginLeft: 8}} src={infoIcon} alt="info-icon"/>}</p>
          {isExpandable && (
            <img
              alt="dropdown"
              src={dropDown}
              style={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "0.5s",
              }}
            />
          )}

          <p className="value">{value}</p>
        </div>
        {isExpanded && dropDownContent}
      </div>
    );
  };

  const renderFeeAndChargesBreakdown = (data) => (
    <div className="expanded-content">
      {Object.entries(data)
        .slice(0, 2)
        .map(([key, val], index) => (
          <li key={index} className="list-content">
            <p>{key}</p>
            <p>{`₹${val}`}</p>
          </li>
        ))}
      {data.info && (
        <div className="info-section">
          <img src={infoIcon} alt="" />
          <p>{data.info}</p>
        </div>
      )}
    </div>
  );

  const renderAddOnsBreakdown = (items) => (
    <div className="add-on-container">
      {items.map(({ label, price, onClick }, idx) => (
        <div key={idx} className="add-ons-content">
          <span>
            {label}
            <strong>{`₹${price}`}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
            <img
              src={infoIcon}
              alt=""
              style={{ height: "18px", width: "21px" }}
              onClick={onClick}
            />
          </span>
        </div>
      ))}
    </div>
  );

  const loanDetails = {
    fee_and_charges_breakdown: renderFeeAndChargesBreakdown({
      [partnerLocDetails?.processing_fee_plus_gst_l]:
        partnerLocDetails?.processing_fee_plus_gst,
      "Broken Period Interest": partnerLocDetails?.upfront_interest,
      info: "Broken Period Interest/Upfront Interest will be applicable when you opt for EMI. Same would be a part of your loan amount to be paid by way of EMI.",
    }),
    add_ons_breakdown: renderAddOnsBreakdown([
      {
        label: `${partnerLocDetails?.max_amount_l} @ `,
        price: partnerLocDetails?.max_amount,
        onClick: handleCreditShieldPopup,
      },
      {
        label: `${partnerLocDetails?.credit_report_fees_l} @ `,
        price: partnerLocDetails?.credit_report_fees,
        onClick: handleCreditReportPopup,
      },
    ]),
  };

  const [showPopup, setShowPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const [showTncPopup, setShowTncPopup] = useState(false);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleTncPopupClose = () => {
    setShowTncPopup(false);
  };

  const handleErrorModalOpen = () => {
    setShowPopup(false);
    setShowErrorPopup(true);
    setBtnDisable(true);
  };

  const handleErrorModalClose = () => {
    setShowErrorPopup(false);
  };

  const detailErrorModalButtons = [
    { label: "Close", onClick: handleErrorModalClose },
  ];

  const fetchPartnerLoc = async (payload) => {
    try {
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const result = await getPartnerLoc({
        jwt_token,
        scrt,
        device_id: deviceid,
        utmSource,
        credit_shield_enable: payload?.credit_shield_enable || false,
        pcr_enable: payload?.pcr_enable || false,
        credit_shield_opt: creditShieldToggleActionPerformed ? creditShieldRef.current : payload?.credit_shield_enable,
        pcr_opt: creditReportToggleActionPerformed ? creditReportRef.current : payload?.pcr_enable,
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        handleErrorModalOpen();
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        
        dispatch(
          setPageError(
            result?.error?.data?.error_message ||
              result?.error?.data?.message ||
              "Please check your internet or try again later."
          )
        );
        handleErrorModalOpen();
      } else {
        const API_RESULT = result.data.data;
        const emiAmountPopupData = {
          totalPayableAmount: API_RESULT.net_amount_payable,
          loanAmount: API_RESULT.approved_amount,
          effectiveRoi: API_RESULT.effective_roi,
          annualPercentageRate: API_RESULT.apr_value,
          interestPayable: API_RESULT.total_interest_pay,
          financeDoc: API_RESULT.financing_documents,
          effectiveAnnualRoi: API_RESULT.effective_annual_roi,
        };
        setEmiAmountData(emiAmountPopupData);
        dispatch(setPartnerLocDetails({ ...result.data?.data }));
        if (result.data.customer_segmentation) {
          localStorage.setItem(
            "customerSegment",
            result.data.customer_segmentation.toLowerCase()
          );
        }
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      handleErrorModalOpen();
    }
  };

  const fetchCustomerFeatureFlag = async () => {
    try {
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const result = await getCustomerFeatureFlag({
        jwt_token,
        scrt,
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        handleErrorModalOpen();
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        dispatch(
          setPageError(
            result?.error?.data?.error_message ||
              result?.error?.data?.message ||
              "Please check your internet or try again later."
          )
        );
        handleErrorModalOpen();
      } else {
        if (!isInitialized.current) {
          setCreditShieldChecked(result?.data?.credit_shield_enable || false);
          setCreditReportChecked(result?.data?.pcr_enable || false);
          isInitialized.current = true;
        }
        dispatch(setCustomerFeatureFlag({ ...result.data }));
        await fetchPartnerLoc(result.data);
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      handleErrorModalOpen();
    }
  };

  useEffect(() => {
    fetchCustomerFeatureFlag();
  }, [
    getCustomerFeatureFlag,
    getPartnerLoc,
    dispatch,
    navigate,
    jwt,
    secret,
    deviceid,
    utmSource,
  ]);

  useEffect(() => {
    if (isInitialized.current) {
      fetchPartnerLoc({
        credit_shield_enable: customerFeatureFlag?.credit_shield_enable,
        pcr_enable: customerFeatureFlag?.pcr_enable,
      });
    }
  }, [creditShieldChecked, creditReportChecked]);

  // totalPayableAmount: "",
  //   loanAmount: "",
  //   effectiveRoi: "",
  //   annualPercentageRate: "",
  //   interestPayable: "",
  //   financeDoc: ""

  useEffect(() => {
    if (partnerLocDetails) {
      const renderAddOnsText = () => {
        if(creditReportChecked && creditReportChecked) {
          return `${partnerLocDetails?.max_amount_l}/${partnerLocDetails?.credit_report_fees_l}`
        }else if(creditReportChecked){
          return partnerLocDetails?.credit_report_fees_l
        }else if(creditShieldChecked) {
          return partnerLocDetails?.max_amount_l
        }else{
          return "No-Add On"
        }
      }

      const renderAddOnAmount = () => {
        if(creditReportChecked && creditReportChecked) {
          return partnerLocDetails?.max_amount || 0 + partnerLocDetails?.credit_report_fees || 0;
        }else if(creditReportChecked){
          return partnerLocDetails?.credit_report_fees;
        }else if(creditShieldChecked) {
          return partnerLocDetails?.max_amount;
        }else{
          return 0;
        }
      }
      pushCleverTapEvent({
        event_name: 'web_loan_details',
        event_property: {
          Source: utmSource,
          "Disbursed Amount": partnerLocDetails?.final_disbursal_amount,
          "Loan amount": partnerLocDetails?.approved_amount,
          "Fee & charges": partnerLocDetails?.fee_and_charges,
          "Add Ons": renderAddOnsText(),
          "Add Ons Amount": renderAddOnAmount(),
          "Amount you will get": partnerLocDetails?.final_disbursal_amount,
          "EMI Start Date": partnerLocDetails?.first_emi_date,
          "No. of EMIs": partnerLocDetails?.tenure,
          "EMI Amount": partnerLocDetails?.emi_amount,
          "segment": localStorage.getItem('customerSegment'),
        }
      })
    }
  }, [partnerLocDetails])

  useEffect(() => {
    if(showPopup) {
      pushCleverTapEvent({
        event_name: 'web_popup_shown',
        event_property: {
          Source: utmSource,
          "popup type": "confirm bank account",
          segment: localStorage.getItem('customerSegment') || "",
        }
      });
    }
  }, [showPopup]);

  const PopupData = () => {
    return (
      <div className="loan-detail-popup">
        <h1 className="title">Confirm your Bank Account</h1>
        {ifscBankDetails && (
          <div style={{marginBottom: 16}}>
            <div className="bank-details">
              <span className="detail-left">Bank Name</span>
              <span className="detail-right">{ifscBankDetails.bank_name}</span>
            </div>
            <div className="bank-details">
              <span className="detail-left">IFSC Code</span>
              <span className="detail-right">{ifscBankDetails.ifsc_code}</span>
            </div>
            <div className="bank-details" style={{borderBottom: 0}}>
              <span className="detail-left">Account Number</span>
              <span className="detail-right">{ifscBankDetails.account_no}</span>
            </div>
          </div>
        )}
        {/* <div className="consent-check">
          <input
            type="checkbox"
            id="termsCheckbox"
            checked={checked}
            onChange={() => {
              setChecked(!checked);
            }}
          />
          <label htmlFor="termsCheckbox">
            <p className="checkbox-msg">
            I have read, understood and accept all the terms in the
              <Link
                to={`${partnerLocDetails?.financing_documents}`}
                target="_blank"
                className="financial-link"
              >
                {" "}
                Financing Documents
              </Link>{" "}
              (including  KFS, Sanction Letter and Loan Agreement).
            </p>
          </label>
        </div> */}
      </div>
    );
  };

  const TncPopupData = () => {
    return (
      <div className="loan-protection-popup">
        <div className="loan-protection-popup__section">
          <h2 className="loan-protection-popup__subtitle">
            Who qualifies for Loan Protection?
          </h2>
          <p className="loan-protection-popup__text">
            Customers who opt for our <strong>"Credit Shield"</strong> and pay
            the charges are eligible for this cover.
          </p>

          <h2 className="loan-protection-popup__subtitle">
            Features of Credit Shield:
          </h2>
          <ul className="loan-protection-popup__list">
            <li>Hassle free and paperless protection</li>
            <li>
              Accidental death benefit: Stashfin loan amount is repaid in case
              of accidental death.
            </li>
            <li>
              Amount of coverage is capped to the extent of outstanding loan
              amount.
            </li>
            <li>
              <strong>Period of Cover:</strong> Policy coverage is applicable
              till the period for which the particular loan is active. The
              policy coverage lapses in the event of loan closure.
            </li>
          </ul>

          <h2 className="loan-protection-popup__subtitle">
            Other Terms and Conditions:
          </h2>
          <ul className="loan-protection-popup__list">
            <li>
              Stashfin reserves the right to seek necessary documents/evidence
              for claim.
            </li>
            <li>
              Premium determination is based on various factors e.g. loan
              amount, customer age, etc.
            </li>
            <li>
              Please feel free to reach out to us for further
              details/clarifications.
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const CreditShieldWarningBox = ({ onStayUnprotected, onProtectMe }) => {
    return (
      <div className="credit-shield-warning">
        <div className="warning-content">
          <Alert className="warning-icon" />
          <p className="warning-text">
            {showCreditShieldPopup || showFinalGatingPopup ? (
              "Skipping out may leave your family responsible for the full loan in unforeseen events."
            ) : showCreditReportPopup ? (
              <>
                <strong>Grow financially</strong>
                <br />
                See how to improve your score and get better loan rates
              </>
            ) : (
              ""
            )}
          </p>
        </div>
        <div className="warning-buttons">
          <button
            className={`btn outlined ${
              showCreditShieldPopup || showCreditReportPopup
                ? "typ-skip"
                : showFinalGatingPopup
                ? "typ-stay-unprotected"
                : ""
            }`}
            onClick={onStayUnprotected}
          >
            {showCreditShieldPopup || showCreditReportPopup
              ? "Skip"
              : showFinalGatingPopup
              ? "Stay unprotected"
              : ""}
          </button>
          <button
            className={`btn filled ${
              showCreditShieldPopup || showCreditReportPopup
                ? "typ-protect-me"
                : showFinalGatingPopup
                ? "typ-final-protect-me"
                : ""
            }`}
            onClick={onProtectMe}
          >
            {showCreditShieldPopup || showFinalGatingPopup
              ? "Protect me"
              : showCreditReportPopup
              ? "Get Report"
              : ""}
          </button>
        </div>
      </div>
    );
  };

  const CreditToggle = ({ type, checked }) => {
    return (
      <div
        className={`credit-shield-toggle-button ${checked ? "on" : ""}`}
        onClick={() => {
          if (type === "credit-shield") {
            setCreditShieldChecked((prev) => !prev);
            setCreditShieldToggleActionPerformed(true);
          } else if (type === "credit-report") {
            setCreditReportChecked((prev) => !prev);
            setCreditReportToggleActionPerformed(true);
          }
        }}
      >
        <div className={`credit-shield-toggle-circle ${checked ? "on" : ""}`}>
          {checked ? <MaroonTick /> : null}
        </div>
      </div>
    );
  };

  const CreditShieldData = () =>
    useMemo(() => {
      const finalGatingInfo = {
        id: "final-gating",
        title: `Credit Shield @ ₹${partnerLocDetails?.max_amount}`,
        baseline: false,
        data: [
          {
            icon: <SquiglyTick />,
            title: "Hassle-free & Paperless",
            description:
              "Get insured instantly with premium deducted from loan",
          },
          {
            icon: <Cars2 />,
            title: "Accidental Death Benefit",
            description:
              "Stashfin loan amount repaid in case of accidental death",
          },
        ],
        terms: !skipCreditShield,
        warning: skipCreditShield,
        skipProtectionOverlay: skipCreditShield,
        checked: creditShieldChecked,
        needToggle: false,
      };

      const creditShieldInfo = {
        id: "credit-shield",
        title: "Why is this Protection important?",
        baseline: {
          icon: <ShieldIcon />,
          text: "Protected by Credit Shield",
        },
        data: [
          {
            icon: <SquiglyTick />,
            title: "Hassle-free & Paperless",
            description:
              "Get insured instantly with premium deducted from loan",
          },
          {
            icon: <Cars2 />,
            title: "Accidental Death Benefit",
            description:
              "Stashfin loan amount repaid in case of accidental death",
          },
        ],
        terms: creditShieldChecked,
        warning: !creditShieldChecked,
        skipProtectionOverlay: false,
        checked: creditShieldChecked,
        needToggle: true,
      };

      const creditReportInfo = {
        id: "credit-report",
        title: "What is Credit Report?",
        baseline: {
          icon: <CreditMeter />,
          text: "Get my Credit Report",
        },
        data: [
          {
            icon: <CreditReport />,
            title: "Credit Score and Summary",
            description:
              "An overview of your credit health, creditworthiness and credit utilization.",
          },
          {
            icon: <RupeeDocs />,
            title: "Account Information",
            description:
              "Displays previous leaders and loan related details with them.",
          },
          {
            icon: <MagnifyDoc />,
            title: "Accidental Death Benefit",
            description:
              "Provide details of all the enquiries made by the lenders.",
          },
        ],
        terms: false,
        warning: !creditReportChecked,
        skipProtectionOverlay: false,
        checked: creditReportChecked,
        needToggle: true,
      };

      // Removed tapClick from here

      const creditInfo = showCreditShieldPopup
        ? creditShieldInfo
        : showCreditReportPopup
        ? creditReportInfo
        : showFinalGatingPopup
        ? finalGatingInfo
        : null;

      if (!creditInfo) return null;

      return (
        <div className="credit-addon-popup-container">
          {creditInfo.skipProtectionOverlay && (
            <div className="credit-overlay-fade" />
          )}
          <div className="credit-addon-popup">
            <h2 className="title">{creditInfo.title}</h2>

            <div className="element-container">
              {creditInfo.data.map((item, index) => (
                <div className="element-wrapper" key={index}>
                  <div className="icon-wrapper">
                    <span className="icon" role="img" aria-label="check">
                      {item.icon}
                    </span>
                  </div>
                  <div className="text-wrapper">
                    <div className="title">{item.title}</div>
                    <div className="description">{item.description}</div>
                    <div className="divider" />
                  </div>
                </div>
              ))}
            </div>

            {creditInfo.needToggle && (
              <div className="credit-shield-toggle">
                <div className="credit-shield-text">
                  <span className="icon">{creditInfo.baseline.icon}</span>
                  &nbsp;&nbsp;
                  {creditInfo.baseline.text}
                  <CreditToggle
                    type={creditInfo.id}
                    checked={creditInfo.checked}
                  />
                </div>
              </div>
            )}

            {creditInfo.terms && (
              <div className="terms">
                By Clicking on <strong>“Protect Me”</strong> I agree to{" "}
                <span
                  style={{ color: "#AA013F", cursor: "pointer" }}
                  onClick={() => {
                    setShowTncPopup(true);
                  }}
                >
                  Terms & Conditions
                </span>
              </div>
            )}
          </div>
          {creditInfo.warning && (
            <CreditShieldWarningBox
              onStayUnprotected={() => {
                pushCleverTapEvent({
                  event_name: 'web_popup_clicked',
                  event_property: {
                    Source: utmSource,
                    "popup type": showCreditShieldPopup ? "Credit Shield" : showCreditReportPopup ? "Credit Report" : "",
                    segment: localStorage.getItem('customerSegment'),
                    CTA: "skip",
                  }
                })
                handleCreditShieldPopupButtons("stay-unprotected");
              }}
              onProtectMe={() => {
                pushCleverTapEvent({
                  event_name: 'web_popup_clicked',
                  event_property: {
                    Source: utmSource,
                    "popup type": showCreditShieldPopup ? "Credit Shield" : showCreditReportPopup ? "Credit Report" : "",
                    segment: localStorage.getItem('customerSegment'),
                    CTA: showCreditShieldPopup ? "Protect me" : showCreditReportPopup ? "Get Report" : showFinalGatingPopup ? "typ-stay-unprotected" : ""
                  }
                })
                handleCreditShieldPopupButtons("stay-unprotected");
              }}
            />
          )}{" "}
        </div>
      );
    }, [
      showCreditShieldPopup,
      showCreditReportPopup,
      creditShieldChecked,
      creditReportChecked,
    ]);

  useEffect(() => {
    if (showCreditShieldPopup || showCreditReportPopup || showFinalGatingPopup) {
      pushCleverTapEvent({
        event_name: 'web_popup_shown',
        event_property: {
          Source: utmSource,
          "popup type": showCreditShieldPopup
            ? "Credit Shield"
            : showCreditReportPopup
            ? "Credit Report"
            : showFinalGatingPopup
            ? "Final Gating"
            : "",
          segment: localStorage.getItem('customerSegment'),
        }
      });
    }
  }, [showCreditShieldPopup, showCreditReportPopup, showFinalGatingPopup]);

  const EmiAmountData = useCallback(() => {
    const numDisplay = (num) => Intl.NumberFormat('en-IN', {style: "currency", currency: "INR", maximumFractionDigits: 0}).format(num)
    const EMI_DATA = [
      {
        label: "Total Payable Amount",
        value: numDisplay(emiAmountData.totalPayableAmount)
      },
      {
        label: "Loan Amount",
        value: numDisplay(emiAmountData.loanAmount)
      },
      {
        label: "Rate of Interest",
        value: `${emiAmountData.effectiveAnnualRoi} %`
      },
      {
        label: "Annualised Percentage Rate",
        value: emiAmountData.annualPercentageRate
      },
      {
        label: "Interest Payable",
        value: numDisplay(emiAmountData.interestPayable)
      },
    ]
    return (
      <div className="emi_amount_popup_container">
        <p className="heading">Emi Amount</p>
        <div className="emi_amount_details">
          {
            EMI_DATA.map((item, index) => (
              <div key={index} style={{paddingBottom: index !== EMI_DATA.length - 1 && 8, display: "flex", justifyContent: "space-between", borderBottom: index !== EMI_DATA.length - 1 && "1px solid #e9e9e9"}}>
                <p style={{fontSize: 14, color: "#1f1f1f"}}>{item.label}</p>
                <p style={{fontSize: 14, fontWeight: 600, color: "#1f1f1f"}}>{item.value}</p>
              </div>
            ))
          }
        </div>
        {/* <p style={{color: "#1f1f1f", marginTop: 16}}>Please refer to <a style={{color: "#0064E0"}} href={emiAmountData.financeDoc} target="_blank" rel="noreferrer">Financing documents</a> for details of applicable interest and charges.</p> */}
      </div>
    )
  }, [emiAmountData])

  const handlebankdetail = async () => {
    pushCleverTapEvent({
      event_name: 'web_popup_clicked',
      event_property: {
        Source: utmSource,
        CTA: "confirm",
        "popup type": "confirm bank account",
        segment: localStorage.getItem('customerSegment'),
      }
    })
    try {
      setChecked(false);
      setdisablebtn(true);
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const result = await DisbursalDisburse({
        jwt_token,
        scrt,
        utmSource,
        deviceid,
        max_amount: creditShieldRef.current ? partnerLocDetails?.max_amount : 0,
        credit_report_fees: creditReportRef.current
          ? partnerLocDetails?.credit_report_fees
          : 0,
        plan_id: creditReportRef.current ? partnerLocDetails?.plan_id : "0",
        journey_type: "",
        consent: [
          {
            consent_type: "ALL_TERMS_IN_LOAN_DOCUMENT",
            consent_status: isChecked ? "ACCEPTED" : "DECLINED",
            consent_text: "I have read, understood and accept all the terms in the Financing Documents (including  KFS, Sanction Letter and Loan Agreement)."
          }
        ],
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
          setChecked(false);
        }
        handleErrorModalOpen();
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
        setdisablebtn(true);
      } else if (result.error) {
        if(result.error?.data?.error_code === 13 && result.error?.data?.error_message === "Error while imps transfer"){
          navigate("/disbursal-waiting")
          return
        }
        if(result.error.data.error_message == 'BRE_REJECTED') {
          navigate(`/rejected`)
        } else if (
          result?.error?.data?.error_message ==
          "Invalid approval details while loan disbursal. Please retry after sametime "
        ) {
          setShowPopup(false);
          setRefreshCountdown(5);
          setShowRefreshPopup(true);
          setdisablebtn(true);
        } else {
          dispatch(
            setPageError(
              result?.error?.data?.error_message ||
                result?.error?.data?.message ||
                "Please check your internet or try again later."
            )
          );
          handleErrorModalOpen();
          setdisablebtn(true);
        }
      } else {
        setdisablebtn(true);
        window.location.href = result.data?.data.redirect_url;
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      handleErrorModalOpen();
      setdisablebtn(true);
    }
  };

  const GetBankInfo = async () => {
    try {
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      const result = await getLoanbankDetails({
        jwt_token,
        scrt,
        utmSource,
        deviceid,
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        handleErrorModalOpen();
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        
        dispatch(
          setPageError(
            result?.error?.data?.error_message ||
              result?.error?.data?.message ||
              "Please check your internet or try again later."
          )
        );
        handleErrorModalOpen();
      } else {
        dispatch(setIfscBankDetails(result.data));
        setShowPopup(true);
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      handleErrorModalOpen();
    }
  };

  const handleTransferMoney = () => {
    pushCleverTapEvent({
      event_name: 'web_transfer_money_now_clicked',
      event_property: {
        Source: utmSource,
        "consent given": isChecked ? "TRUE" : "FALSE",
        segment: localStorage.getItem('customerSegment'),
      }
    })
    let showGating = false;
    if (creditShieldToggleActionPerformed) {
      showGating = false;
    } else {
      if (customerFeatureFlag?.credit_shield_enable) {
        showGating = false;
      } else {
        showGating = true;
      }
    }

    if (showGating) {
      handleFinalGatingPopup();
    } else {
      GetBankInfo();
    }
  };

  const detailModalButtons = [{ label: "Confirm", onClick: handlebankdetail }];

  const creditPopupButtons = [
    {
      label: "Protect Me",
      className: "customCreditPopup-button1",
      onClick: handleProtectMeButtonClick,
    },
    {
      label: "Skip",
      className: "customCreditPopup-button2",
      onClick: handleFinalGatingSkip,
    },
    {
      label: "Get Report",
      className: "customCreditPopup-button1",
      onClick: handleCreditReportPopupClose,
    },
  ];

  const getCreditPopupButtons = () => {
    if (showCreditReportPopup) {
      if (creditReportChecked) {
        return [creditPopupButtons[2]];
      } else {
        return [];
      }
    } else if (showCreditShieldPopup) {
      if (creditShieldChecked) {
        return [creditPopupButtons[0]];
      } else {
        return [];
      }
    } else if (showFinalGatingPopup) {
      if (skipCreditShield) {
        return [];
      } else {
        return [...creditPopupButtons.slice(0, 2)];
      }
    } else {
      return [];
    }
  };

  return (
    <div className="external-wrapper">
      <CenteredPopup
        isOpen={showErrorPopup}
        buttons={detailErrorModalButtons}
        onClose={handleErrorModalClose}
        icon={<WarningIcon />}
      >
        {pageerror}
      </CenteredPopup>

      <CenteredPopup
        isOpen={showRefreshPopup}
        buttons={[]}
        onClose={() => window.location.reload()}
        icon={<WarningIcon />}
      >
        <p>Something went wrong</p>
        <p>Reloading in {refreshCountdown}</p>
      </CenteredPopup>

      <CenteredPopup
        isOpen={showPopup}
        buttons={detailModalButtons}
        onClose={handleClose}
        disabled={disablebtn}
      >
        <PopupData />
      </CenteredPopup>

      <CenteredPopup
        isOpen={showTncPopup}
        buttons={[]}
        onClose={handleTncPopupClose}
        className="tnc-pop-up-container"
      >
        <TncPopupData />
      </CenteredPopup>

      <BottomPopup
        isOpen={
          showCreditShieldPopup || showCreditReportPopup || showFinalGatingPopup
        }
        buttons={getCreditPopupButtons()}
        onClose={handleCreditPopupClose}
        disabled={false}
        closeIcon={"filled"}
        className={"customCreditPopup"}
        closeClassName={"customCreditPopup-close"}
        bodyClassName={`customCreditPopup-body ${
          (showCreditShieldPopup && !creditShieldChecked) ||
          (showCreditReportPopup && !creditReportChecked) ||
          (showFinalGatingPopup && skipCreditShield)
            ? "removeBodyBottomMargin"
            : ""
        }`}
        footerClassName={"customCreditPopup-footer"}
      >
        <CreditShieldData />
      </BottomPopup>

      <BottomPopup
        isOpen={showEmiAmountPopup}
        onClose={handleEmiReportPopupClose}
        disabled={false}
        closeIcon={"filled"}
        className={"customCreditPopup"}
        closeClassName={"customCreditPopup-close"}
        bodyClassName={`customCreditPopup-body`}
        footerClassName={"customCreditPopup-footer"}
      >
        <EmiAmountData />
      </BottomPopup>

      {isLoading && (
        <div className="loader-wrapper">
          <div className="loader-content">
            <div className="loader"></div>
            <p>Fetching your details—this won’t take long!</p>
          </div>
        </div>
      )}

      <div className="page-content">
        <div className="loan-detail-container">
          <PageHeader />
          <div className="title-section">
            <div className="left-section">
              <h1 className="title">Loan Details</h1>
              <h2 className="sub-heading">
                {partnerLocDetails?.final_disbursal_amount_l}
              </h2>
              <h1 className="amount">
                ₹{partnerLocDetails?.final_disbursal_amount}
              </h1>
            </div>
            <img alt="" src={giftImage} />
          </div>

          <div className="loan-term-info-section">
            <p>
              <span>KFS Summary: </span>
              {partnerLocDetails?.emi_card_description}
            </p>
          </div>

          <div className="loan-info-list-container">
            <LoanInfoTile
              id="loan"
              label={partnerLocDetails?.loan_amount_l}
              value={`₹${partnerLocDetails?.requested_amount || ""}`}
            />
            <LoanInfoTile
              id="fee"
              label={partnerLocDetails?.fee_and_charges_l}
              value={`₹${partnerLocDetails?.fee_and_charges}`}
              isExpandable={true}
              isExpanded={expandedTile === "fee"}
              onToggleExpand={() => handleToggleExpand("fee")}
              dropDownContent={loanDetails.fee_and_charges_breakdown}
            />
            <LoanInfoTile
              id="add_on"
              label={partnerLocDetails?.add_on_l}
              value={`₹${
                (creditShieldRef.current ? partnerLocDetails?.max_amount : 0) +
                (creditReportRef.current
                  ? partnerLocDetails?.credit_report_fees
                  : 0)
              }`}
              isExpandable={true}
              isExpanded={expandedTile === "add_on"}
              onToggleExpand={() => handleToggleExpand("add_on")}
              dropDownContent={loanDetails.add_ons_breakdown}
            />
            <LoanInfoTile
              id="disbursement"
              label={partnerLocDetails?.final_disbursal_amount_l}
              value={`₹${partnerLocDetails?.final_disbursal_amount}`}
            />
            <LoanInfoTile
              id="first_emi_date"
              label={partnerLocDetails?.first_emi_date_l}
              value={`${partnerLocDetails?.first_emi_date}`}
            />
            <LoanInfoTile
              id="tenure"
              label={partnerLocDetails?.number_of_emi_l}
              value={`${partnerLocDetails?.tenure}`}
            />
            <LoanInfoTile
              id="emi"
              label={partnerLocDetails?.emi_amount_l}
              value={`₹${partnerLocDetails?.emi_amount}`}
              showDivider={false}
              showInfoIcon
              onInfoIconClick={handleEmiReportPopup}
            />
          </div>

          <div className="checkbox-container">
            <input
              type="checkbox"
              id="myCheckbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <p>
              I have read, understood and accept all the terms in the
              <span
                onClick={() => window.open(partnerLocDetails?.financing_documents)}
              >
                {" "}
                Financing Documents  
              </span>
              &nbsp;(including  KFS, Sanction Letter and Loan Agreement).
            </p>
          </div>
        </div>

        <div className="bottom-footer">
          <p className="powered-by">
            Powered by <StarfinLogo />
          </p>
          <button
            type="button"
            disabled={!isChecked || btnDisable}
            className={`btn btn-primary ${!isChecked || btnDisable ? "disabledClass" : ""}`}
            onClick={() => {
              handleTransferMoney();
            }}
          >
            Transfer Money Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoanDetail;
